import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  View,
  Text,
  FlatList,
  Animated,
  Easing,
  ScrollView,
  useWindowDimensions,
  BackHandler,
} from 'react-native';

import { ADD, CHECK, PLUS, RIGHT_CHECK } from '../../../assets';
import { GUEST_REQUEST_DETAILS } from '../../../navigation/StackNavigator/routes';
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useDispatch, useSelector } from 'react-redux';
import { getGuestRequestList } from '../../../Redux/Actions/guestRequestAction';
import { calculateTimeDifference, generateToken, getCleanUrl } from '../../../utils/Helper';
import { useTranslation } from 'react-i18next';
import { clearSelectedItems, updateSelectedRequestItems } from '../../../Redux/Reducers/guestRequestReducer';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import CustomPressable from '../../../components/customPressable/customPressable';
import { getDataLoadingScreen } from '../../../js/getDataLoadingScreen';
import CustomFlatList from '../../../components/customFlatList';
import { setGoHome, setShowLoginModal } from '../../../Redux/Reducers/appConfigReducer';
import InfoPopupModal from '../../../components/infoPopupModal';
import FetchingDataScreen from '../../../components/fetchingDataScreen';
import { setRenderFlashMessage } from '../../../Redux/Actions/appConfigAction';
import { sendAnalytics } from '../../../Redux/Actions/analyticsAction';
import { CLICKED, EXIT, GUEST_REQUEST_CATEGORY, INITIAL_LOADER_SCREEN } from '../../../config/Constant';
import RenderHTML from 'react-native-render-html';
import { useFocusEffect } from '@react-navigation/native';

const GuestRequest_Landscape = ({ navigation }) => {

  const [widgetLaunchTime, setWidgetLaunchTime] = useState(() => new Date());
  const [guestRequestSessionId, setGuestRequestSessionId] = useState(() => generateToken("guestRequest_"));


  const dispatch = useDispatch();
  const getStyles = useCssStyle();
  const { t } = useTranslation();
  const {width} = useWindowDimensions();
  



  const { isLoggedIn } = useSelector((state) => state.appConfigSlice);
  const { selectedItems } = useSelector(state => state.guestRequestSlice);
  const selectedItemsLengthRef = useRef(selectedItems.length || 0);

  const [guestrequestInfoData, setGuestRequestInfoData] = useState({})
  const [widgetDisplayName, setWidgetDisplayName] = useState(t("guestRequest.heading"));

  const { currentWidget } = useSelector(state => state.deviceConfigSlice);
  const storeName = currentWidget?.displayName; 
  const widgetMetaHtmlId = currentWidget?.widgetMetaHtmlId;



  const [initialLoading, setInitialLoading] = useState(false);

  const [loaderState, setLoaderState] = useState({
    showLoader: false,
    loaderMessage: ""
  });

  const toggleLoaderState = (state, message) => {
    setLoaderState({
      showLoader: state,
      loaderMessage: state ? message : ""
    })
  }


  const [errorState, setErrorState] = useState({
    isError: false,
    errorMessage: ""
  })

  const toggleErrorState = (state, message) => {
    setErrorState({
      isError: state,
      errorMessage: state ? message : ""
    })
  }


  const [showAttentionPopup, setShowAttentionPopup] = useState(false);




  const handleClosePopup = () => {
    setShowAttentionPopup(false);
  };

  const handleCustomBackPress = (forceGoHome) => {
    
    if (selectedItemsLengthRef.current > 0 && !forceGoHome) {
      setShowAttentionPopup(true);
      return true;
    };

    dispatch(setGoHome(true));
    return true;
  };



  const handleMyRequestPress = () => {
    navigation.navigate(GUEST_REQUEST_DETAILS, {
      widgetDisplayName: widgetDisplayName,
      guestRequestSessionId: guestRequestSessionId
    });
  };

  const toggleItemSelection = item => {
    dispatch(updateSelectedRequestItems(item));
  };



  let scaleAnimation = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    selectedItemsLengthRef.current = selectedItems?.length || 0;

    Animated.sequence([
      Animated.timing(scaleAnimation, {
        toValue: 1.5, // Increase size
        duration: 200,
        easing: Easing.ease,
        useNativeDriver: true,
      }),
      Animated.timing(scaleAnimation, {
        toValue: 1, // Return to original size
        duration: 200,
        easing: Easing.ease,
        useNativeDriver: true,
      })
    ]).start();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);




  const fetchGuestRequests = async () => {

    setInitialLoading(true);


    const fetchGuestRequestsResponse = await dispatch(getGuestRequestList(currentWidget.storeSku));

    setInitialLoading(false);
    if (fetchGuestRequestsResponse.status == "SUCCESS") {
      setGuestRequestInfoData(fetchGuestRequestsResponse.response);
    } else {
      toggleErrorState(true, fetchGuestRequestsResponse.message)
    }
  };


  useEffect(() => {
    setWidgetDisplayName((!Array.isArray(guestrequestInfoData) && guestrequestInfoData?.name) || currentWidget?.displayName);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentWidget, guestrequestInfoData])

  useFocusEffect(useCallback(() => {
    const backHandler = BackHandler.addEventListener('hardwareBackPress', handleCustomBackPress);
    return () => backHandler.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]))

  useEffect(() => {

    if (!isLoggedIn) {
      dispatch(setGoHome(true));
      dispatch(setShowLoginModal(true));
      return;
    }

    if (currentWidget.storeSku) {
      fetchGuestRequests();
    } else {
      dispatch(setGoHome(true));
      dispatch(setRenderFlashMessage(true, { type: "danger", message: "Store not found" }));
    }

    dispatch(sendAnalytics(GUEST_REQUEST_CATEGORY, CLICKED, { element: "widget", "widgetSessionId": guestRequestSessionId, storeSku: currentWidget.storeSku, storeName: storeName}))
    return () => {
      dispatch(clearSelectedItems());
      const widgetCloseTime = new Date;
      const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
      dispatch(sendAnalytics(GUEST_REQUEST_CATEGORY, EXIT, {element: "widget", duration: widgetCloseDuration, "widgetSessionId": guestRequestSessionId, storeSku: currentWidget.storeSku, storeName: storeName}))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderGuestRequestList = (guestrequestInfoData) => {
    return guestrequestInfoData?.requestMaster?.map((item, index) => {
      const isSelected = selectedItems.some(
        selectedItem => selectedItem.serviceRequestId === item.serviceRequestId
      );
      return (
        <CustomPressable 
          style={getStyles(['list_itemContainer', 'guestrequest_landscape_childcontainer_itemContainer', `guestrequest_landscape_childcontainer_itemContainer_${widgetMetaHtmlId}`, isSelected && 'guestrequest_landscape_childcontainer_itemContainer_selected'])} 
          onPress={() => toggleItemSelection(item)}
          id={`list_itemContainer guestrequest_landscape_childcontainer_itemContainer guestrequest_landscape_childcontainer_itemContainer_${widgetMetaHtmlId} ${isSelected ? 'guestrequest_landscape_childcontainer_itemContainer_selected' : ""}`}
          key={`guestrequest_landscape_childcontainer_itemContainer_selected_${index}`}
        >

          {item?.imageName && <ImageComp
            source={getCleanUrl(item?.imageName)}
            style={getStyles(['list_itemContainer_image', 'guestrequest_landscape_childcontainer_itemContainer_image', isSelected && 'guestrequest_landscape_childcontainer_itemContainer_image_selected'])}
            id={`list_itemContainer_image guestrequest_landscape_childcontainer_itemContainer_image ${isSelected ? 'guestrequest_landscape_childcontainer_itemContainer_image_selected' : ""}`}
          />}

          <View 
            style={getStyles(['list_itemContainer_textContainer', 'guestrequest_landscape_childcontainer_itemContainer_textContainer', isSelected && 'guestrequest_landscape_childcontainer_itemContainer_textContainer_selected'])}
            id={`list_itemContainer_textContainer guestrequest_landscape_childcontainer_itemContainer_textContainer ${isSelected ? 'guestrequest_landscape_childcontainer_itemContainer_textContainer_selected' : ""}`}
          >
            {item?.name && <Text 
              style={getStyles(['list_itemContainer_textContainer_title', 'guestrequest_landscape_childcontainer_itemContainer_textContainer_title', isSelected && 'guestrequest_landscape_childcontainer_itemContainer_textContainer_title_selected'])}
              id={`list_itemContainer_textContainer_title guestrequest_landscape_childcontainer_itemContainer_textContainer_title ${isSelected ? 'guestrequest_landscape_childcontainer_itemContainer_textContainer_title_selected' : ""}`}
            >{item.name}</Text>}
            {item?.description && <Text 
              style={getStyles(['list_itemContainer_textContainer_subtitle', 'guestrequest_landscape_childcontainer_itemContainer_textContainer_subtitle', isSelected && 'guestrequest_landscape_childcontainer_itemContainer_textContainer_subtitle_selected'])} 
              id={`list_itemContainer_textContainer_subtitle guestrequest_landscape_childcontainer_itemContainer_textContainer_subtitle ${isSelected ? 'guestrequest_landscape_childcontainer_itemContainer_textContainer_subtitle_selected' : ""}`}
              numberOfLines={2} 
              ellipsizeMode="tail"
            >{item.description}</Text>}
          </View>

          <View 
            style={getStyles(['list_itemContainer_arrow', 'guestrequest_landscape_childcontainer_itemContainer_arrow', isSelected && 'guestrequest_landscape_childcontainer_itemContainer_arrow_selected'])}
            id={`list_itemContainer_arrow guestrequest_landscape_childcontainer_itemContainer_arrow ${isSelected ? 'guestrequest_landscape_childcontainer_itemContainer_arrow_selected' : ""}`}
          >
            <ImageComp 
              source={isSelected ? CHECK : PLUS} 
              style={getStyles(['list_itemContainer_arrow_img', 'guestrequest_landscape_childcontainer_itemContainer_arrow_img', isSelected && 'guestrequest_landscape_childcontainer_itemContainer_arrow_img_selected'])}
              id={`list_itemContainer_arrow_img guestrequest_landscape_childcontainer_itemContainer_arrow_img ${isSelected ? 'guestrequest_landscape_childcontainer_itemContainer_arrow_img_selected' : ""}`}
            />
          </View>
        </CustomPressable>
      )
    })
  }

  const customGuestRequestTitleStyle = getStyles([
    'widgetmainContainerHeaderTitle',
    'guestrequest_landscape_HeaderTitle'
  ]);

  return (
    <View style={getStyles(['widgetRootContainer', 'guestrequest_landscape_RootContainer'])} id={`widgetRootContainer guestrequest_landscape_RootContainer`}>
      <HeaderWithBack handleCustomBackPress={handleCustomBackPress} />
      
      <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['widgetmainContainer', 'guestrequest_landscape_MainContainer'])} id='widgetmainContainer guestrequest_landscape_MainContainer'>

        <View style={getStyles(['widgetmainContainerHeaderContainer', 'guestrequest_landscape_HeaderContainer'])} id='widgetmainContainerHeaderContainer guestrequest_landscape_HeaderContainer'>
          {
            currentWidget?.widgetHeaderImageUrl &&
            <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'guestrequest_landscape_HeaderImg'])} id='widgetmainContainerHeaderImg guestrequest_landscape_HeaderImg' />
          }
          <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'guestrequest_landscape_HeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer guestrequest_landscape_HeaderTitleContainer'>
            <RenderHTML 
              contentWidth={width}
              baseStyle={customGuestRequestTitleStyle}
              source={{html: widgetDisplayName || t("guestRequest.heading")}}
              systemFonts={ Array.isArray(customGuestRequestTitleStyle.fontFamilyArr) ? customGuestRequestTitleStyle.fontFamilyArr : [customGuestRequestTitleStyle.fontFamily]}
              id={`widgetmainContainerHeaderTitle guestrequest_landscape_HeaderTitle`}
            />
          </View>
        </View>

        <View style={getStyles(['widgetmainContainerChildContainer', 'guestrequest_landscape_MainContainerChildContainer'])} id='widgetmainContainerChildContainer guestrequest_landscape_MainContainerChildContainer'>

          {!Array.isArray(guestrequestInfoData) 
            ? <View style={getStyles(['guestrequest_landscape_NonArrayItemContainer'])} id='guestrequest_landscape_NonArrayItemContainer' >
              {renderGuestRequestList(guestrequestInfoData)}
            </View>

            : guestrequestInfoData.map((item, index)=> (
              <View key={`widgetmainContainerChildTitleContainer_${index}`}>
                <View style={getStyles(['widgetmainContainerChildTitleContainer', 'guestrequest_landscape_ChildTitleContainer'])} id='widgetmainContainerChildTitleContainer guestrequest_landscape_ChildTitleContainer'>
                  <Text style={getStyles(['widgetmainContainerChildTitle', 'guestrequest_landscape_ChildTitle'])} id='widgetmainContainerChildTitle guestrequest_landscape_ChildTitle'>{item?.name}</Text>
                </View>
                <View style={getStyles(["guestrequest_landscape_list_container"])} id='guestrequest_landscape_list_container'>
                  {renderGuestRequestList(item)}
                </View>
              </View>
            ))}
        </View>

      </ScrollView>

      {selectedItems.length > 0 && (
        <View style={getStyles(['footer_button_container', 'guestrequest_landscape_button_container'])} id='footer_button_container guestrequest_landscape_button_container'>

          <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleMyRequestPress} id='primaryBtn'>
            <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
              {t('guestRequest.my_request')}
            </Text>
            <Animated.View style={[getStyles(['myOrder_container_count_container']), { transform: [{ scale: scaleAnimation }] }]} id="myOrder_container_count_container">
              <Text style={getStyles(['myOrder_container_count_container_text'])} id='myOrder_container_count_container_text'>{selectedItems.length}</Text>
            </Animated.View>
          </CustomPressable>
        </View>
      )}

      {showAttentionPopup &&
        <InfoPopupModal
          title={"Attention!"}
          subtitle={t('guestRequest.attention_info')}
          onClose={handleClosePopup}
          OnRequestClose={handleClosePopup}
          secondaryBtnLabel={"No"}
          onContinue={(() => handleCustomBackPress(true))}
          primaryBtnLabel={"Yes"}
        />
      }

      {errorState.errorMessage &&
        <InfoPopupModal
          subtitle={errorState.errorMessage}
          onClose={() => { toggleErrorState(false); handleCustomBackPress() }}
          OnRequestClose={() => { toggleErrorState(false); handleCustomBackPress() }}
          secondaryBtnLabel={"Back"}
          onContinue={() => { toggleErrorState(false); fetchGuestRequests() }}
          primaryBtnLabel={"Try again"}
        />
      }

      {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
      {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}

    </View>
  );
};




export default GuestRequest_Landscape;
